import React, { useContext, useState } from "react";
import { useQuery } from "@apollo/client";
import {
  GET_TRANSFER_REQUESTS_BY_PLAYER_ACCEPTED_OR_TEAM_ACCEPTED,
  TRANSFER_REQUESTS_WITH_PERMISSION,
} from "../../GraphQL/TransferRequests";
import { GET_PLAYERS } from "../../GraphQL/Players";
import { GET_TEAMS } from "../../GraphQL/Teams";
import LoadingSpinner from "../../Components/UI/LoadingSpinner.js";
import PageError from "../../Components/UI/PageError.js";
import PageLayout from "../../Components/UI/PageLayout.js";
import TransferRequestsTable from "../../Components/TransferRequests/TransferRequestsTable.js";
import NewTransferRequestButton from "../../Components/TransferRequests/NewTransferRequestButton.js";
import NewTransferRequestDialog from "../../Components/TransferRequests/NewTransferRequestDialog.js";
import PageFAB from "../../Components/UI/PageFAB.js";
import { LoginContext } from "../../Components/Login/LoginContext";

const TransferRequestPage = () => {
  const transferRequests = useQuery(
    GET_TRANSFER_REQUESTS_BY_PLAYER_ACCEPTED_OR_TEAM_ACCEPTED
  );

  const players = useQuery(GET_PLAYERS);
  const teams = useQuery(GET_TEAMS);
  const transferRequestsWithPermission = useQuery(
    TRANSFER_REQUESTS_WITH_PERMISSION
  );

  const [auth] = useContext(LoginContext);
  const [fabOpen, setFabOpen] = useState(false);

  const queryError =
    transferRequests.error ||
    players.error ||
    transferRequestsWithPermission.error ||
    teams.error;
  if (queryError) {
    return (
      <PageError
        message={queryError.message}
        onRetry={() => {
          transferRequests.refetch();
          players.refetch();
          transferRequestsWithPermission.refetch();
          teams.refetch();
        }}
      />
    );
  }

  if (
    transferRequests.loading ||
    players.loading ||
    transferRequestsWithPermission.loading ||
    teams.loading
  )
    return <LoadingSpinner />;

  return (
    <PageLayout
      title="Transfer Market"
      breadcrumbs={[{ label: "Home", to: "/" }, { label: "Transfer Market" }]}
      actions={
        auth.loggedIn && (
          <NewTransferRequestButton
            players={players.data.players}
            teams={teams.data.teams}
          />
        )
      }
    >
      <TransferRequestsTable
        transferRequestsWithPermission={
          transferRequestsWithPermission.data.transferRequestsWithPermission
        }
        transferRequests={
          transferRequests.data.transferRequestsByPlayerAcceptedOrTeamAccepted
        }
        players={players.data.players}
        teams={teams.data.teams}
      />
      {auth.loggedIn && (
        <>
          <PageFAB label="Create Transfer Request" onClick={() => setFabOpen(true)} />
          <NewTransferRequestDialog
            open={fabOpen}
            setOpen={setFabOpen}
            players={players.data.players}
            teams={teams.data.teams}
          />
        </>
      )}
    </PageLayout>
  );
};

export default TransferRequestPage;
